(function () {
  function markCustomilyLoaded() {
    const optionsRoot = document.getElementById('customily-options');
    const optionsApp = document.querySelector('#cl_optionsapp');

    if (optionsRoot && optionsApp && optionsApp.children.length > 0) {
      optionsRoot.classList.add('is-loaded');
      optionsApp.classList.add('is-loaded');
    }
  }

  function setImportantStyle(element, property, value) {
    element.style.setProperty(property, value, 'important');
  }

  function applyImportantStyles(element, styles) {
    Object.entries(styles).forEach(([property, value]) => {
      setImportantStyle(element, property, value);
    });
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function addCustomilyLabels() {
    // Only inject labels for image-based swatches. Text Swatch options already
    // render `.label-text`, and adding `.label-txt` duplicates SportsSports, etc.
    const swatches = document.querySelectorAll(
      '#cl_optionsapp .choose-style-options .customily-swatch, #cl_optionsapp .image-upload-options .customily-swatch'
    );

    swatches.forEach((swatch) => {
      const label = swatch.querySelector('label');
      if (!label) return;

      if (!label.querySelector('.label-txt')) {
        let text =
          label.getAttribute('title') ||
          swatch.getAttribute('data-title') ||
          '';

        if (!text) {
          const input = swatch.querySelector('input');
          if (input) {
            text = input.value || input.getAttribute('value') || '';
          }
        }

        if (text) {
          const textEl = document.createElement('div');
          textEl.className = 'label-txt';
          textEl.textContent = text;
          label.appendChild(textEl);
        }
      }
    });

    markCustomilyLoaded();
  }

  function fixCustomilySections() {
    const sectionTargets = document.querySelectorAll(
      '#cl_optionsapp .customily_section, #cl_optionsapp .customily_section__accordion_body, #cl_optionsapp .customily_sets-panel, #cl_optionsapp .customily_sets-container, #cl_optionsapp .customily-set, #cl_optionsapp .customily-set-visibility'
    );

    sectionTargets.forEach((section) => {
      applyImportantStyles(section, {
        background: '#f8f8f8',
        'background-color': '#f8f8f8',
      });
    });
  }

  function stabilizeCustomilyHeight() {
    const slot = document.getElementById('customily-options');
    const app = document.querySelector('#cl_optionsapp');
    if (!slot || !app) return;

    const height = app.offsetHeight;
    if (!height) return;

    const fontStyle = document.querySelector('#cl_optionsapp .custom-font-style');
    const customTextFlowOpen = !!(fontStyle && fontStyle.offsetHeight > 0);
    const targetMin = customTextFlowOpen ? Math.max(height, 560) : height;
    const nextMin = `${targetMin}px`;

    slot.style.setProperty('min-height', nextMin, 'important');
    app.style.setProperty('min-height', nextMin, 'important');
  }

  function getOptionLabel(option) {
    const raw = option.querySelector('.option_name')?.textContent || '';
    return raw.replace(/\s+/g, ' ').trim().split('*')[0].trim();
  }

  function tagCustomilyOptions() {
    document.querySelectorAll('#cl_optionsapp .customily_option').forEach((option) => {
      const name = getOptionLabel(option);

      if (/choose font style/i.test(name)) {
        option.classList.add('custom-font-style');
      }

      if (/font color|design color/i.test(name)) {
        option.classList.add('custom-design-color');
      }

      if (/^(sports|signature|minimal)$/i.test(name)) {
        option.classList.add(`${name.toLowerCase()}-font-family`);
      }
    });
  }

  function fixFontStyleSwatches() {
    const option = document.querySelector('#cl_optionsapp .custom-font-style');
    if (!option) return;

    option.querySelectorAll('.label-txt').forEach((duplicate) => {
      duplicate.remove();
    });

    option.querySelectorAll('.carousel-edge').forEach((edge) => {
      applyImportantStyles(edge, { display: 'none' });
    });

    option.querySelectorAll('.swatch-container, .c-carousel').forEach((target) => {
      applyImportantStyles(target, {
        display: 'block',
        width: '100%',
        'max-width': '100%',
        overflow: 'visible',
      });
    });

    option.querySelectorAll('.carousel-track').forEach((target) => {
      applyImportantStyles(target, {
        display: 'grid',
        'grid-template-columns': 'repeat(3, minmax(0, 1fr))',
        gap: '6px',
        width: '100%',
        'max-width': '100%',
        overflow: 'visible',
      });
    });

    option.querySelectorAll('.customily-swatch').forEach((swatch) => {
      const label = swatch.querySelector('label');
      const input = swatch.querySelector('input');
      if (!label) return;

      const isChecked = !!input?.checked;

      applyImportantStyles(swatch, {
        width: '100%',
        'min-width': '0',
        margin: '0',
      });

      applyImportantStyles(label, {
        width: '100%',
        'min-width': '0',
        'max-width': 'none',
        height: '50px',
        'min-height': '50px',
        'max-height': '50px',
        display: 'flex',
        'flex-direction': 'row',
        'align-items': 'center',
        'justify-content': 'center',
        gap: '0',
        padding: '0 8px',
        border: isChecked ? '1px solid #151515' : '1px solid #d8d8d8',
        'border-radius': '6px',
        background: '#fff',
        'box-sizing': 'border-box',
        overflow: 'hidden',
        outline: 'none',
        'box-shadow': 'none',
      });

      label.querySelectorAll('.label-txt, .label-text').forEach((text) => {
        applyImportantStyles(text, {
          display: 'block',
          margin: '0',
          padding: '0',
          'font-size': '12px',
          'line-height': '1.2',
          'font-weight': '600',
          color: '#151515',
          'text-align': 'center',
          'white-space': 'normal',
          position: 'static',
        });
      });
    });
  }

  function getLabelBackgroundColor(label) {
    if (label.style.backgroundColor) {
      return label.style.backgroundColor;
    }

    const match = label.getAttribute('style')?.match(/background-color:\s*([^;!]+)/i);
    return match ? match[1].trim() : '';
  }

  function fixFontFamilySwatches() {
    const options = document.querySelectorAll(
      '#cl_optionsapp .sports-font-family, #cl_optionsapp .signature-font-family, #cl_optionsapp .minimal-font-family'
    );

    options.forEach((option) => {
      applyImportantStyles(option, {
        width: '100%',
        display: 'flex',
        'padding-left': '5px',
        'padding-right': '5px',
        'box-sizing': 'border-box',
      });

      option.querySelectorAll('.cl-accordion, .cl-option-content').forEach((wrap) => {
        applyImportantStyles(wrap, {
          width: '100%',
          display: 'block',
        });
      });

      option.querySelectorAll('.carousel-edge').forEach((edge) => {
        applyImportantStyles(edge, { display: 'none' });
      });

      option.querySelectorAll('.swatch-container, .c-carousel').forEach((target) => {
        applyImportantStyles(target, {
          display: 'block',
          width: '100%',
          'max-width': '100%',
          overflow: 'visible',
        });
      });

      option.querySelectorAll('.carousel-track').forEach((target) => {
        applyImportantStyles(target, {
          display: 'grid',
          'grid-template-columns': 'repeat(auto-fill, minmax(50px, 1fr))',
          gap: '6px',
          width: '100%',
          'max-width': '100%',
          overflow: 'visible',
        });
      });

      option.querySelectorAll('.customily-swatch').forEach((swatch) => {
        const label = swatch.querySelector('label');
        const input = swatch.querySelector('input');
        if (!label) return;

        const isChecked = !!input?.checked;

        applyImportantStyles(swatch, {
          width: 'auto',
          'min-width': '0',
          margin: '0',
        });

        applyImportantStyles(label, {
          width: '50px',
          'min-width': '50px',
          'max-width': '50px',
          height: '50px',
          'min-height': '50px',
          'max-height': '50px',
          display: 'flex',
          'align-items': 'center',
          'justify-content': 'center',
          padding: '0',
          border: isChecked ? '1px solid #151515' : '1px solid #d8d8d8',
          'border-radius': '6px',
          background: '#fff',
          'box-sizing': 'border-box',
          overflow: 'hidden',
          outline: 'none',
          'box-shadow': 'none',
        });
      });

      option.querySelectorAll('.csh-image-visible, .customily-swatch img').forEach((image) => {
        applyImportantStyles(image, {
          width: '100%',
          height: '100%',
          'max-width': '50px',
          'max-height': '50px',
          display: 'block',
          margin: '0',
          'object-fit': 'contain',
          position: 'static',
        });
      });
    });
  }

  function fixFontColorSwatches() {
    const options = document.querySelectorAll('#cl_optionsapp .custom-design-color');

    options.forEach((option) => {
      applyImportantStyles(option, {
        width: '100%',
        display: 'flex',
        'padding-left': '5px',
        'padding-right': '5px',
        'box-sizing': 'border-box',
      });

      option.querySelectorAll('.cl-accordion, .cl-option-content').forEach((wrap) => {
        applyImportantStyles(wrap, {
          width: '100%',
          display: 'block',
        });
      });

      option.querySelectorAll('.carousel-edge').forEach((edge) => {
        applyImportantStyles(edge, { display: 'none' });
      });

      option.querySelectorAll('.swatch-container, .c-carousel').forEach((target) => {
        applyImportantStyles(target, {
          display: 'block',
          width: '100%',
          'max-width': '100%',
          overflow: 'visible',
        });
      });

      option.querySelectorAll('.carousel-track').forEach((target) => {
        applyImportantStyles(target, {
          display: 'grid',
          'grid-template-columns': 'repeat(auto-fill, minmax(50px, 1fr))',
          gap: '6px',
          width: '100%',
          'max-width': '100%',
          overflow: 'visible',
        });
      });

      option.querySelectorAll('.customily-swatch').forEach((swatch) => {
        const label = swatch.querySelector('label');
        const input = swatch.querySelector('input');
        if (!label) return;

        const isChecked = !!input?.checked;
        const backgroundColor = getLabelBackgroundColor(label);

        applyImportantStyles(swatch, {
          width: 'auto',
          'min-width': '0',
          margin: '0',
        });

        const labelStyles = {
          width: '50px',
          'min-width': '50px',
          'max-width': '50px',
          height: '50px',
          'min-height': '50px',
          'max-height': '50px',
          display: 'flex',
          'align-items': 'center',
          'justify-content': 'center',
          padding: '0',
          border: isChecked ? '1px solid #151515' : '1px solid #d8d8d8',
          'border-radius': '6px',
          'box-sizing': 'border-box',
          overflow: 'hidden',
          outline: 'none',
          'box-shadow': 'none',
        };

        if (backgroundColor) {
          labelStyles['background-color'] = backgroundColor;
        }

        applyImportantStyles(label, labelStyles);
      });
    });
  }

  function fixChooseStyleSwatches() {
    const optionsApp = document.querySelector('#cl_optionsapp');
    const option = document.querySelector('#cl_optionsapp .choose-style-options');
    if (!option) return;

    const mobile = isMobileViewport();

    if (optionsApp) {
      applyImportantStyles(optionsApp, {
        background: '#f8f8f8',
        padding: '6px 14px 14px',
        'border-radius': '4px',
        width: '100%',
        'box-sizing': 'border-box',
      });
    }

    const optionsSlot = document.getElementById('customily-options');
    if (optionsSlot) {
      applyImportantStyles(optionsSlot, {
        background: '#f8f8f8',
        'border-radius': '4px',
        width: '100%',
      });
    }

    option.querySelectorAll('.c-carousel').forEach((carousel) => {
      applyImportantStyles(carousel, {
        width: '100%',
        'max-width': '100%',
        display: 'block',
      });
    });

    option.querySelectorAll('.carousel-edge').forEach((edge) => {
      applyImportantStyles(edge, { display: 'none' });
    });

    option.querySelectorAll('.swatch-container').forEach((target) => {
      applyImportantStyles(target, {
        display: 'block',
        width: '100%',
        'max-width': '100%',
        overflow: 'visible',
      });
    });

    option.querySelectorAll('.carousel-track').forEach((target) => {
      applyImportantStyles(target, {
        display: 'grid',
        'grid-template-columns': 'repeat(3, minmax(0, 1fr))',
        gap: '6px',
        width: '100%',
        'max-width': '100%',
        overflow: 'visible',
      });
    });

    option.querySelectorAll('.customily-swatch').forEach((swatch) => {
      applyImportantStyles(swatch, {
        width: '100%',
        'min-width': '0',
        margin: '0',
        'align-items': 'center',
        'text-align': 'center',
      });

      const label = swatch.querySelector('label');
      const input = swatch.querySelector('input');
      if (!label) return;

      const isChecked = !!input?.checked;

      applyImportantStyles(label, mobile
        ? {
            position: 'relative',
            width: '100%',
            'min-width': '0',
            'max-width': 'none',
            height: 'auto',
            'min-height': '76px',
            'max-height': 'none',
            display: 'flex',
            'flex-direction': 'column',
            'align-items': 'center',
            'justify-content': 'center',
            gap: '0',
            padding: '8px 4px 10px',
            border: isChecked ? '1px solid #151515' : '1px solid #d8d8d8',
            'border-radius': '6px',
            background: '#fff',
            'box-sizing': 'border-box',
            overflow: 'hidden',
            outline: 'none',
            'box-shadow': 'none',
          }
        : {
            position: 'relative',
            width: '100%',
            'min-width': '0',
            'max-width': 'none',
            height: '50px',
            'min-height': '50px',
            'max-height': '50px',
            display: 'flex',
            'flex-direction': 'row',
            'align-items': 'center',
            'justify-content': 'flex-start',
            gap: '0',
            padding: '0',
            border: isChecked ? '1px solid #151515' : '1px solid #d8d8d8',
            'border-radius': '6px',
            background: '#fff',
            'box-sizing': 'border-box',
            overflow: 'hidden',
            outline: 'none',
            'box-shadow': 'none',
          });

      label.querySelectorAll(':scope > *').forEach((child) => {
        applyImportantStyles(child, {
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
        });
      });

      const text = label.querySelector('.label-txt');
      if (text) {
        applyImportantStyles(text, mobile
          ? {
              position: 'static',
              display: 'block',
              'align-items': 'center',
              'justify-content': 'center',
              margin: '0',
              padding: '6px 2px 0',
              flex: '0 0 auto',
              width: '100%',
              'min-width': '0',
              'min-height': '0',
              'font-size': '11px',
              'line-height': '1.15',
              'font-weight': '600',
              color: '#151515',
              background: 'transparent',
              border: 'none',
              'border-radius': '0',
              'white-space': 'normal',
              'text-align': 'center',
              overflow: 'hidden',
              'box-sizing': 'border-box',
            }
          : {
              position: 'static',
              display: 'flex',
              'align-items': 'center',
              'justify-content': 'center',
              margin: '0',
              padding: '0 4px',
              flex: '1 1 0',
              width: 'auto',
              'min-width': '0',
              'min-height': '0',
              'font-size': '12px',
              'line-height': '1.2',
              'font-weight': '600',
              color: '#151515',
              background: 'transparent',
              border: 'none',
              'border-radius': '0',
              'white-space': 'normal',
              'text-align': 'center',
              overflow: 'hidden',
              'box-sizing': 'border-box',
            });
      }
    });

    option.querySelectorAll('.csh-image-container').forEach((wrap) => {
      applyImportantStyles(wrap, mobile
        ? {
            position: 'static',
            width: '100%',
            'min-width': '0',
            'max-width': 'none',
            height: '36px',
            'min-height': '36px',
            'max-height': '36px',
            margin: '0',
            padding: '0',
            flex: '0 0 36px',
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'center',
            background: 'transparent',
            overflow: 'hidden',
          }
        : {
            position: 'static',
            width: '50px',
            'min-width': '50px',
            'max-width': '50px',
            height: '50px',
            'min-height': '50px',
            'max-height': '50px',
            margin: '0',
            padding: '0',
            flex: '0 0 50px',
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'center',
            background: 'rgba(0, 0, 0, 0.04)',
            overflow: 'hidden',
          });
    });

    option.querySelectorAll('.csh-image-visible, .customily-swatch label img').forEach((image) => {
      const swatch = image.closest('.customily-swatch');
      const isChecked = !!swatch?.querySelector('input')?.checked;
      const iconSize = mobile ? '30px' : '34px';

      applyImportantStyles(image, {
        position: 'static',
        width: iconSize,
        height: iconSize,
        'min-width': iconSize,
        'min-height': iconSize,
        'max-width': iconSize,
        'max-height': iconSize,
        display: 'block',
        margin: '0',
        'object-fit': 'contain',
        transform: isChecked ? 'scale(1.2)' : 'none',
        transition: 'transform 0.15s ease',
      });
    });
  }

  function fixImageUploadSwatches() {
    const option = document.querySelector('#cl_optionsapp .image-upload-options');
    if (!option) return;

    applyImportantStyles(option, {
      width: '100%',
      display: 'block',
    });

    option.querySelectorAll('.carousel-edge').forEach((edge) => {
      applyImportantStyles(edge, { display: 'none' });
    });

    option.querySelectorAll('.swatch-container, .c-carousel, .carousel-track').forEach((target) => {
      applyImportantStyles(target, {
        width: '100%',
        'max-width': '100%',
        margin: '0',
        padding: '0',
        display: 'flex',
        'flex-direction': 'row',
        'flex-wrap': 'nowrap',
        gap: '6px',
        overflow: 'visible',
        'mask-image': 'none',
        '-webkit-mask-image': 'none',
      });
    });

    option.querySelectorAll('.customily-swatch').forEach((swatch) => {
      const input = swatch.querySelector('input');
      const isChecked = !!input?.checked;

      applyImportantStyles(swatch, {
        flex: '1 1 0',
        width: 'auto',
        'min-width': '0',
        'max-width': 'none',
        margin: '0',
        'align-items': 'stretch',
        'text-align': 'center',
        background: 'transparent',
        'border-radius': '0',
        border: 'none',
        overflow: 'visible',
        outline: '0',
        'box-shadow': 'none',
      });

      const label = swatch.querySelector('label');
      if (!label) return;

      applyImportantStyles(label, {
        width: '100%',
        'min-width': '0',
        'max-width': 'none',
        height: 'auto',
        'min-height': '118px',
        'max-height': 'none',
        display: 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
        'justify-content': 'flex-start',
        gap: '0',
        padding: '8px 6px 10px',
        border: isChecked ? '1px solid #151515' : '1px solid #d8d8d8',
        'border-radius': '5px',
        background: '#fff',
        'box-sizing': 'border-box',
        'text-align': 'center',
        overflow: 'hidden',
        outline: '0',
        'box-shadow': 'none',
      });

      label.querySelectorAll(':scope > *').forEach((child) => {
        applyImportantStyles(child, {
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          transform: 'none',
        });
      });
    });

    option.querySelectorAll('.csh-image-container').forEach((wrap) => {
      applyImportantStyles(wrap, {
        width: '100%',
        height: '72px',
        'min-width': '0',
        'min-height': '72px',
        'max-width': 'none',
        'max-height': '72px',
        flex: '0 0 72px',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        margin: '0',
        padding: '0',
        overflow: 'hidden',
      });
    });

    option.querySelectorAll('.csh-image-visible, .customily-swatch img').forEach((image) => {
      applyImportantStyles(image, {
        width: 'auto',
        height: 'auto',
        'min-width': '0',
        'min-height': '0',
        'max-width': '64px',
        'max-height': '64px',
        'aspect-ratio': '1',
        display: 'block',
        margin: '0',
        'border-radius': '5px',
        'object-fit': 'contain',
        position: 'static',
      });
    });

    option.querySelectorAll('.label-txt').forEach((text) => {
      applyImportantStyles(text, {
        display: 'block',
        margin: '8px 0 0',
        padding: '0 2px',
        width: '100%',
        'max-width': '100%',
        'font-size': '11px',
        'line-height': '1.2',
        'font-weight': '600',
        color: '#151515',
        'text-align': 'center',
        'white-space': 'normal',
        'box-sizing': 'border-box',
        position: 'static',
      });
    });
  }

  const UPLOAD_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12"/><path d="M7 8l5-5 5 5"/><path d="M5 21h14"/></svg>';

  function ensureUploadIcon(option) {
    if (option.querySelector('.added-icon-wrapper')) return;

    const iconWrapper = document.createElement('div');
    iconWrapper.className = 'added-icon-wrapper';
    iconWrapper.innerHTML = UPLOAD_ICON_SVG;
    option.insertBefore(iconWrapper, option.firstChild);
  }

  function fixImageUploadField() {
    const uploadOptions = document.querySelectorAll(
      '#cl_optionsapp .customily_option:not(.choose-style-options):not(.image-upload-options)'
    );

    uploadOptions.forEach((option) => {
      if (!option.querySelector('.customily-file-input')) return;

      option.classList.add('image-upload-field');
      ensureUploadIcon(option);

      applyImportantStyles(option, {
        display: 'flex',
        'flex-direction': 'row',
        'flex-wrap': 'nowrap',
        'align-items': 'center',
        'justify-content': 'flex-start',
        width: '100%',
        'max-width': '100%',
        'box-sizing': 'border-box',
        border: '2px dashed #d9d9d9',
        'border-radius': '5px',
        padding: '13px',
        margin: '13px 0 5px',
        background: '#fff',
        gap: '0',
      });

      option.querySelectorAll('.added-icon-wrapper').forEach((iconWrap) => {
        applyImportantStyles(iconWrap, {
          display: 'inline-flex',
          'align-items': 'center',
          'justify-content': 'center',
          flex: '0 0 auto',
          width: 'auto',
          padding: '10px',
          margin: '0 5px 0 0',
          background: '#f8f8f8',
          cursor: 'default',
        });
      });

      const headerLabel = option.querySelector(':scope > label');
      if (headerLabel) {
        applyImportantStyles(headerLabel, {
          display: 'flex',
          flex: '1 1 auto',
          'align-items': 'center',
          width: 'auto',
          'min-width': '0',
          margin: '0',
          padding: '0',
          border: 'none',
          background: 'transparent',
          cursor: 'default',
          'pointer-events': 'none',
        });
      }

      option.querySelectorAll('.option_number').forEach((number) => {
        applyImportantStyles(number, { display: 'none' });
      });

      option.querySelectorAll('.option_name').forEach((name) => {
        applyImportantStyles(name, {
          display: 'inline-flex',
          'align-items': 'center',
          width: 'auto',
          margin: '0',
          padding: '0',
          'font-size': '14px',
          'font-weight': '400',
          color: '#151515',
        });
      });

      option.querySelectorAll('.option_name .customily-required-label').forEach((required) => {
        applyImportantStyles(required, { display: 'none' });
      });

      option.querySelectorAll(':scope > .cl-accordion').forEach((accordion) => {
        applyImportantStyles(accordion, {
          display: 'flex',
          flex: '0 0 auto',
          'flex-direction': 'row',
          'align-items': 'center',
          'justify-content': 'flex-end',
          width: 'auto',
          margin: '0 0 0 auto',
          padding: '0',
          border: 'none',
          background: 'transparent',
        });
      });

      option.querySelectorAll('.customily-file-input, .cl-container, .cl-flex-no-wrap').forEach((wrap) => {
        applyImportantStyles(wrap, {
          display: 'flex',
          'align-items': 'center',
          'justify-content': 'flex-end',
          width: 'auto',
          margin: '0',
          padding: '0',
        });
      });

      option.querySelectorAll('.customily-download-button, .cl_remove-image').forEach((button) => {
        applyImportantStyles(button, {
          display: 'inline-flex',
          'align-items': 'center',
          'justify-content': 'center',
          border: '1px solid #090909',
          'border-radius': '30px',
          padding: '10px 20px',
          margin: '0',
          background: 'transparent',
          'background-color': 'transparent',
          color: '#151515',
          'font-size': '13px',
          'line-height': '1.2',
          'font-weight': '400',
          'box-shadow': 'none',
          outline: 'none',
          cursor: 'pointer',
          'pointer-events': 'auto',
          height: 'auto',
          'min-height': '0',
          width: 'auto',
          appearance: 'none',
        });
      });
    });
  }

  let designConfirmationInitialized = false;

  function getDesignConfirmationElements() {
    const section = document.getElementById('customily-design-confirmation');
    if (!section) return null;

    return {
      section,
      checkbox: section.querySelector('[data-customily-design-confirm]'),
      error: section.querySelector('.customily-design-confirmation__error'),
      thumb: section.querySelector('[data-customily-preview-thumb]'),
      expandButton: section.querySelector('[data-customily-preview-expand]'),
    };
  }

  function getPreviewCanvas() {
    return document.getElementById('preview-canvas');
  }

  function closeFallbackPreviewModal() {
    const fallback = document.querySelector('[data-customily-preview-fallback]');
    if (!fallback) return;

    fallback.hidden = true;
    fallback.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('customily-design-preview-open');
  }

  function openFallbackPreviewModal() {
    const fallback = document.querySelector('[data-customily-preview-fallback]');
    const expanded = document.querySelector('[data-customily-preview-expanded]');
    const thumb = document.querySelector('[data-customily-preview-thumb]');
    const canvas = getPreviewCanvas();
    if (!fallback || !expanded) return;

    let previewSrc = thumb?.src || '';

    if (canvas) {
      try {
        const dataUrl = canvas.toDataURL('image/png');
        if (dataUrl && dataUrl !== 'data:,') {
          previewSrc = dataUrl;
        }
      } catch (error) {
        // Fall back to the thumbnail if the canvas cannot be exported.
      }
    }

    if (!previewSrc) return;

    expanded.src = previewSrc;
    fallback.hidden = false;
    fallback.setAttribute('aria-hidden', 'false');
    document.body.classList.add('customily-design-preview-open');
  }

  function openDesignPreviewModal() {
    updateDesignPreviewThumb();
    openFallbackPreviewModal();
  }

  function updateDesignPreviewThumb() {
    const elements = getDesignConfirmationElements();
    const canvas = getPreviewCanvas();
    if (!elements?.thumb || !canvas || elements.section.hidden) return;

    try {
      const dataUrl = canvas.toDataURL('image/png');
      if (dataUrl && dataUrl !== 'data:,') {
        elements.thumb.src = dataUrl;
      }
    } catch (error) {
      // Canvas may be tainted or not ready yet.
    }
  }

  function restoreUnblockedAddToCartButtons() {
    document.querySelectorAll('[data-customily-design-blocked]').forEach((button) => {
      const wasDisabled = button.getAttribute('data-customily-design-blocked-previous-disabled') === 'true';
      button.removeAttribute('data-customily-design-blocked');
      button.removeAttribute('data-customily-design-blocked-previous-disabled');
      button.disabled = wasDisabled;
    });
  }

  function blockAddToCartButtons() {
    document.querySelectorAll('.add-to-cart-button, .sticky-add-to-cart__button').forEach((button) => {
      if (button.hasAttribute('data-customily-design-blocked')) return;

      button.setAttribute(
        'data-customily-design-blocked-previous-disabled',
        button.disabled ? 'true' : 'false'
      );
      button.setAttribute('data-customily-design-blocked', 'true');
      button.disabled = true;
    });
  }

  function validateDesignConfirmation({ showError = false } = {}) {
    const elements = getDesignConfirmationElements();
    if (!elements?.section || !elements.checkbox) return true;

    if (elements.section.hidden) {
      restoreUnblockedAddToCartButtons();
      if (elements.error) elements.error.hidden = true;
      elements.section.classList.remove('has-error');
      return true;
    }

    const isValid = elements.checkbox.checked;

    if (isValid) {
      restoreUnblockedAddToCartButtons();
    } else {
      blockAddToCartButtons();
    }

    if (elements.error) {
      elements.error.hidden = !showError || isValid;
    }

    elements.section.classList.toggle('has-error', showError && !isValid);
    return isValid;
  }

  function revealDesignConfirmationIfStyleChosen() {
    const elements = getDesignConfirmationElements();
    const chooseStyle = document.querySelector('#cl_optionsapp .choose-style-options');
    if (!elements?.section || !chooseStyle) return false;

    const selected = chooseStyle.querySelector('input:checked');
    if (!selected) return false;

    elements.section.hidden = false;
    elements.section.setAttribute('aria-hidden', 'false');
    updateDesignPreviewThumb();
    validateDesignConfirmation();
    return true;
  }

  function initDesignConfirmation() {
    if (designConfirmationInitialized) {
      revealDesignConfirmationIfStyleChosen();
      updateDesignPreviewThumb();
      validateDesignConfirmation();
      return;
    }

    const elements = getDesignConfirmationElements();
    const chooseStyle = document.querySelector('#cl_optionsapp .choose-style-options');
    const form = document.querySelector('product-form-component form');
    if (!elements?.section || !chooseStyle || !form) return;

    designConfirmationInitialized = true;

    const reveal = () => {
      revealDesignConfirmationIfStyleChosen();
    };

    chooseStyle.addEventListener('change', reveal);
    chooseStyle.addEventListener('click', reveal);

    elements.checkbox.addEventListener('change', () => {
      validateDesignConfirmation();
    });

    elements.expandButton?.addEventListener('click', (event) => {
      event.preventDefault();
      openDesignPreviewModal();
    });

    document.querySelector('[data-customily-preview-close]')?.addEventListener('click', () => {
      closeFallbackPreviewModal();
    });

    document.querySelector('[data-customily-preview-fallback]')?.addEventListener('click', (event) => {
      if (event.target === event.currentTarget) {
        closeFallbackPreviewModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeFallbackPreviewModal();
      }
    });

    form.addEventListener(
      'submit',
      (event) => {
        if (validateDesignConfirmation({ showError: true })) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        elements.section.scrollIntoView({ behavior: 'smooth', block: 'center' });
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        const stickyButton = event.target.closest('.sticky-add-to-cart__button');
        if (!stickyButton || elements.section.hidden) return;
        if (validateDesignConfirmation({ showError: true })) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        elements.section.scrollIntoView({ behavior: 'smooth', block: 'center' });
      },
      true
    );

    reveal();
  }

  function onCustomilyUpdate() {
    tagCustomilyOptions();
    addCustomilyLabels();
    fixCustomilySections();
    fixChooseStyleSwatches();
    fixFontStyleSwatches();
    fixFontFamilySwatches();
    fixFontColorSwatches();
    fixImageUploadSwatches();
    fixImageUploadField();
    stabilizeCustomilyHeight();
    markCustomilyLoaded();
    initDesignConfirmation();
    updateDesignPreviewThumb();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onCustomilyUpdate);
  } else {
    onCustomilyUpdate();
  }

  const observer = new MutationObserver(onCustomilyUpdate);
  observer.observe(document.body, { childList: true, subtree: true });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(onCustomilyUpdate, 150);
  });
})();
